// extracted by mini-css-extract-plugin
module.exports = {"tags":"SelectTag_tags__TJksl","selectTag":"SelectTag_selectTag__6XJUm","BsX":"SelectTag_BsX__1VnU6","tagInput":"SelectTag_tagInput__2AI6h"};